export default {
    selectAppNewsList: '/gateway/manageBedrock/free/newscs/selectAppNewsList', // 新闻列表查询
}



// WEBPACK FOOTER //
// ./src/news/index/api.js